import sessionTypes from '@clearscore/constants.session-action-types';
import { setSessionCookie } from '@clearscore/helpers.cookies';

/**
 * Check if action has login success type required required for middleware
 * @param {object} action redux action
 * @returns {boolean} if action structure is correct
 */
function _isLoginSuccess(action) {
    return action.type === sessionTypes.LOGIN_OAUTH_AUTHORISE_SUCCESS;
}

/**
 * Handle the storing the session within the cookie
 * @param {function} next next middleware func
 * @param {object} action redux action
 * @returns {void}
 */
function _handleStoringSession(next, action) {
    setSessionCookie({
        access_token: action.payload.access_token,
        refresh_token: action.payload.refresh_token,
        session_id: action.requestData.session_id,
        market: action.requestMeta.market_id,
        remember: action.requestMeta.remember,
        o_token: action.requestMeta.sso_token,
    });
    next(action);
}

/**
 * If action has correct signature, perform cookie storage
 * @returns {Function} middleware
 */
const sessionMiddleware = () => () => (next) => (action) =>
    _isLoginSuccess(action) ? _handleStoringSession(next, action) : next(action);

export default sessionMiddleware;
